/** Émis depuis la carte (popup marqueur) pour ouvrir la modale de gestion côté barre d’interventions. */
export const INTERVENTION_OPEN_MANAGE_EVENT = 'opsecours:intervention-open-manage';

export type InterventionOpenManageEventDetail = {
  instanceId: number;
};
